type Props = {
  theme?: 'light' | 'dark' | 'color'
}

export function YouTubeIcon({ theme = 'color' }: Props) {
  if (theme === 'color') {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="18"
        viewBox="0 0 461.001 461.001"
      >
        <path
          fill="#F61C0D"
          d="M365.257,67.393H95.744C42.866,67.393,0,110.259,0,163.137v134.728
          c0,52.878,42.866,95.744,95.744,95.744h269.513c52.878,0,95.744-42.866,95.744-95.744V163.137
          C461.001,110.259,418.135,67.393,365.257,67.393z M300.506,237.056l-126.06,60.123
          c-3.359,1.602-7.239-0.847-7.239-4.568V168.607c0-3.774,3.982-6.22,7.348-4.514l126.06,63.881
          C304.363,229.873,304.298,235.248,300.506,237.056z"
        />
      </svg>
    )
  }

  const fillColor = theme === 'dark' ? '#828282' : '#000000'

  return (
    <svg
      width="21"
      height="16"
      viewBox="0 0 21 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="transition-all"
        d="M20.5547 2.66264C20.3153 1.76174 19.6104 1.05159 18.7147 0.810545C17.0924 0.373535 10.5849 0.373535 10.5849 0.373535C10.5849 0.373535 4.07747 0.373535 2.45429 0.810545C1.55946 1.05159 0.854522 1.76087 0.615207 2.66264C0.179932 4.29622 0.179932 7.70386 0.179932 7.70386C0.179932 7.70386 0.179932 11.1115 0.615207 12.7451C0.854522 13.646 1.55946 14.3561 2.45516 14.5972C4.07747 15.0342 10.5849 15.0342 10.5849 15.0342C10.5849 15.0342 17.0924 15.0342 18.7156 14.5972C19.6104 14.3561 20.3153 13.6468 20.5555 12.7451C20.9899 11.1115 20.9899 7.70386 20.9899 7.70386C20.9899 7.70386 20.9899 4.29622 20.5547 2.66264ZM8.45711 10.7985V4.60924L13.8955 7.70386L8.45711 10.7985Z"
        fill={fillColor}
      />
    </svg>
  )
}
